import React from 'react';
import PropTypes from 'prop-types';
import Button from '../components/atoms/Button';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ArrowRight } from 'lucide-react';

const CTA = ({
	title,
	customTitle,
	customDesc,
	bgimage,
	serviceHeroImage,
	btn,
	props
}) => {
	const CTABGImage = () => (
		<GatsbyImage
			className="clip_path_1 clip_path_2_mobile object-cover object-center"
			image={getImage(bgimage ? bgimage : serviceHeroImage)}
			style={{
				left: '0',
				width: '100%',
				height: '100%',
				top: '0',
				zIndex: '1',
				position: 'absolute',
				opacity: '1'
			}}
			alt=""
		/>
	);

	return (
		<div className="relative py-16 bg-gradient-to-br from-navbar-to via-brand-600 to-navbar-from my-12">
			<div
				className="hidden absolute inset-0 overflow-hidden lg:block"
				aria-hidden="true"
			>
				<svg
					className="absolute top-0 left-full transform -translate-y-1/4 -translate-x-2/3 xl:top-0 xl:-translate-y-1/3"
					width={404}
					height={384}
					fill="none"
					viewBox="0 0 404 384"
					aria-hidden="true"
				>
					<defs>
						<pattern
							id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
							x={0}
							y={0}
							width={20}
							height={20}
							patternUnits="userSpaceOnUse"
						>
							<rect
								x={0}
								y={0}
								width={4}
								height={4}
								fill="#f4bd1a"
								opacity="0.3"
							/>
						</pattern>
					</defs>
					<rect
						width={404}
						height={384}
						fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
					/>
				</svg>
				<svg
					className="absolute top-1/2 transform -translate-y-1/4 -translate-x-1/4 xl:-translate-y-1/3"
					width={404}
					height={384}
					fill="none"
					viewBox="0 0 404 384"
					aria-hidden="true"
				>
					<defs>
						<pattern
							id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d-2"
							x={0}
							y={0}
							width={20}
							height={20}
							patternUnits="userSpaceOnUse"
						>
							<rect
								x={0}
								y={0}
								width={4}
								height={4}
								fill="#2D5A3D"
								opacity="0.25"
							/>
						</pattern>
					</defs>
					<rect
						width={404}
						height={384}
						fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d-2)"
					/>
				</svg>
				<svg
					className="absolute bottom-0 left-1/2 transform -translate-x-1/2"
					width={400}
					height={200}
					fill="none"
					viewBox="0 0 400 200"
					aria-hidden="true"
				>
			
				</svg>
			</div>
			<div className="relative h-[400px] -mt-12 md:mt-0 aspect-video md:absolute top-[-32px] md:w-[calc(50%-16px)] md:h-[calc(100%+64px)]">
				<div 
					data-gatsby-image-wrapper="" 
					style={{
						left: '0',
						width: '100%',
						height: '100%',
						top: '0',
						zIndex: '1',
						position: 'absolute'
					}} 
					className="gatsby-image-wrapper gatsby-image-wrapper-constrained object-cover object-center aspect-video shadow-2xl"
				>
					{bgimage || serviceHeroImage ? (
						<CTABGImage />
					) : (
						<div className="w-full h-full bg-gray-300"></div>
					)}
				</div>
			</div>
			
			<div className="max-w-7xl mx-auto flex overflow-hidden">
				<div className="hidden md:block w-1/2"></div>
				<div className="relative w-full md:w-1/2 md:py-12 px-4 space-y-6 sm:py-12 sm:px-6">
					<div className="space-y-2">
						<h2 className="text-3xl font-bold text-white" id="join-heading">
							{customTitle ? customTitle : (title || "Ready to Transform Your Home?")}
						</h2>
						{/* Decorative underline */}
						<div className="w-24 h-1 bg-gradient-to-r from-primary to-accent-red rounded-full"></div>
					</div>
					<p className="text-lg text-white">
						{customDesc || "Discover the difference that dedication and expertise make. Contact us today to schedule a consultation and take the first step towards a home that's as robust and welcoming as the communities we serve."}
					</p>
					<Button
						to="/contact/"
						title={`Get Started with ${title || 'Start Your Project Today!'}`}
						className="font-display inline-flex outline-none active:scale-[.97] transition px-4 py-3 md:py-3 md:px-6 text-sm font-semibold rounded-xl transition duration-200 ease-in-out text-black bg-brand-600 hover:bg-brand-700 disabled:text-brand-600 disabled:bg-brand-600 focus:ring-4 focus:ring-brand-400 items-center justify-center border-2 border-white"
					>
						<span className="flex items-center">
							Get Started 
							<ArrowRight size={16} className="ml-2" />
						</span>
					</Button>
				</div>
			</div>
		</div>
	);
};

CTA.propTypes = {
	title: PropTypes.string,
	btn: PropTypes.string
};

export default CTA;
